import "components/jiffy/redrawn-image-review-expiry/redrawn-image-review-expiry";

document.addEventListener("contextmenu", e => e.preventDefault());
